// Copyright (c) 2019 Deere & Company

import React, {PropTypes} from 'react';
import LabeledString from '../../../../shared/components/labeled-string/index';
import Warranty from '@deere/cps-it.warranty-model-factory/lib/warranty';

const WarrantyCoverageItemRowPlanName = props =>
    <div className='warranty-coverage-item-row-plan-name'>
        <LabeledString
            className='plan-name'
            data={props.warranty.planName}
            label='PLAN_NAME'
        />
    </div>;

WarrantyCoverageItemRowPlanName.displayName = 'WarrantyCoverageItemRowPlanName';
WarrantyCoverageItemRowPlanName.propTypes = {
    warranty: PropTypes.instanceOf(Warranty).isRequired
};

export default WarrantyCoverageItemRowPlanName;



// WEBPACK FOOTER //
// ./src/product/details/components/warranty-coverage-panel/warranty-coverage-item-row-plan-name.js